 varying float vAlpha;
      uniform vec3 baseColor;
      float glowMask(){
        vec2 uv = gl_PointCoord - vec2(0.5);
        float d = dot(uv, uv);
        return smoothstep(0.25, 0.0, d) * pow(1.0 - d, 2.0);
      }

      void main(){
        float mask = glowMask();
        float alpha = vAlpha * mask;
        gl_FragColor = vec4(baseColor, alpha);
      }